import { ActualStop, InventoryReceiptType, JobStopType, RequestedStop } from '@ironsight/types'
import { standardizeInventoryList } from '@/utils/inventories'
import { isEqual } from 'lodash'

export type StopCompletionStatus = {
  locationMatches: boolean
  inventoryMatches: boolean
}

export function isRequestedStopCompleted(
  requestedStop: RequestedStop,
  actualStop: ActualStop | undefined,
): StopCompletionStatus {
  if (!actualStop) {
    return {
      locationMatches: false,
      inventoryMatches: false,
    }
  }

  const completionStatus: StopCompletionStatus = {
    locationMatches: requestedStop.locationId === actualStop.locationId,
    inventoryMatches: true,
  }

  if (requestedStop.stopType === JobStopType.PickUp) {
    const driverReceipts = (actualStop.inventoryReceipts ?? []).filter(
      (r) =>
        (actualStop.stopType === JobStopType.PickUp &&
          r.receiptType === InventoryReceiptType.Receiver) ||
        (actualStop.stopType === JobStopType.DropOff &&
          r.receiptType === InventoryReceiptType.Originator),
    )

    const requestedInventory = standardizeInventoryList(requestedStop.inventory ?? [])
    const actualInventory = standardizeInventoryList(driverReceipts)

    completionStatus.inventoryMatches = isEqual(requestedInventory, actualInventory)
  }

  return completionStatus
}
